var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.46754C12.5 3.10908 12.9029 2.88436 13.2267 3.0622L16.75 4.99731L20.6941 7.16352C20.8832 7.26742 21 7.46077 21 7.6702V12L17.3524 9.99664C16.9792 9.79164 16.5208 9.79164 16.1476 9.99664L12.5 12V7.33154V3.46754ZM4 12V7.6702C4 7.46077 4.11675 7.26742 4.30592 7.16352L7.64757 5.3282C8.02084 5.12316 8.47916 5.12316 8.85243 5.3282L12.5 7.33154L4 12ZM12.5 20.5325C12.5 20.8909 12.0971 21.1157 11.7733 20.9378L8.25 19.0027L4.30592 16.8365C4.11675 16.7326 4 16.5392 4 16.3298V12L7.64757 14.0033C8.02084 14.2084 8.47916 14.2084 8.85243 14.0033L12.5 12V16.6685V20.5325ZM16.1476 18.6718C16.5208 18.8768 16.9792 18.8768 17.3524 18.6718L20.6941 16.8365C20.8832 16.7326 21 16.5392 21 16.3298V12L12.5 16.6685L16.1476 18.6718Z",
    fill: "#159DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsIcon);
export default __webpack_public_path__ + "static/media/lets-icon.df7bed57be49d1595908da010f466a5d.svg";
export { ForwardRef as ReactComponent };